<!--
  Who wrote a pull request: "by", their avatar and their login ("ghost"
  when GitHub names no author). The avatar is round and small, so it reads
  as a person and apart from the repository's square mark and the
  reviewers' larger faces.
-->
<script lang="ts">
  import Avatar from './Avatar.svelte';

  interface Props {
    login: string | null | undefined;
    avatarUrl: string | null | undefined;
    size?: number;
  }
  let { login, avatarUrl, size = 16 }: Props = $props();
  const name = $derived(login ?? 'ghost');
</script>

<span class="author-mark"><span class="author-by">by</span> <Avatar url={avatarUrl} {name} {size} /> <span class="author-login">{name}</span></span>

<style>
  .author-mark {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
  }
  .author-login {
    color: var(--fg);
  }
</style>
